import request from '@/utils/request'

/**
 * 查询需要审核的店铺列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryNeedAuditShop(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryNeedAuditShop',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 审核店铺
 * @param {Object} data 审核数据
 * @returns {Promise} Promise对象
 */
export function auditShop(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.auditShop',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}